// import ReactApexChart  from 'react-apexcharts'
import { Box, Typography, Stack } from '@mui/material';

import { CircularProgressbarWithChildren } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { grey } from '@mui/material/colors';

import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';

import './style.scss';

const formatDate = (dateStr) => {
  const date = new Date(dateStr);
  const day = date.getDate();
  const month = date.toLocaleString("en-US", { month: "short" });
  const year = date.getFullYear();

  const getOrdinal = (num) => {
    if (num > 3 && num < 21) return "th";
    switch (num % 10) {
      case 1: return "st";
      case 2: return "nd";
      case 3: return "rd";
      default: return "th";
    }
  };

  return `${day}${getOrdinal(day)} ${month}, ${year}`;
};

const formatDateWithoutYear = (dateStr) => {
  const date = new Date(dateStr);
  const day = date.getDate();
  const month = date.toLocaleString("en-US", { month: "short" });

  const getOrdinal = (num) => {
    if (num > 3 && num < 21) return "th";
    switch (num % 10) {
      case 1: return "st";
      case 2: return "nd";
      case 3: return "rd";
      default: return "th";
    }
  };

  return `${day}${getOrdinal(day)} ${month}`;
};

const formatNumber = (num) => {
  return num.toLocaleString();
};


const FeaturedChart = ({ parishReport }) => {

  if (!parishReport?.success) return null;

  const { attendanceStatData, newMemberData, } = parishReport;

  const attendancePercentage = attendanceStatData.attendancePercentage || 0;
  const totalMembers = formatNumber(attendanceStatData.recentSundayCount || 0);
  const recentAnalytics = attendanceStatData.recentSundaysAnalytics || [];

  return (
    <Box
      p={3}
      bgcolor="#fcfcfc"
      id="chart"
      flex={1.3}
      // minWidth={470}
      // minWidth={{xs: '80%', lg: 470}}
      display={{ lg: 'flex' }}
      flexDirection="column"
      borderRadius="15px"
      boxShadow="2px 4px 10px 1px rgba(201,201,201,0.47)"
    // display='none'
    >
      <Typography fontSize={18} fontWeight={600} color="#808191">
        Total Members as at {formatDate(attendanceStatData.recentSundayDate)}
      </Typography>

      <Stack
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        gap="8px"
        padding="15px"
      // bgcolor={'green'}
      >
        <Typography m={0} fontSize="30px">{totalMembers}</Typography>

        <Typography color="#585858" fontWeight="500" textTransform="capitalize">
          attendance - member percentage
        </Typography>

        <Stack height="100px" width="100px">
          <CircularProgressbarWithChildren
            value={attendancePercentage}
            strokeWidth={10}
            styles={{
              root: { width: 100 },
              path: { stroke: `#000080` },
              trail: { stroke: `#e4e8ef` },
              text: { fill: grey[800], fontSize: '1.5rem' },
              textStyle: {
                fill: grey[800],
                fontSize: '1.5rem',
                dominantBaseline: 'middle',
                textAnchor: 'middle',
              },
            }}
          >
            <div style={{ fontSize: '1.5rem', fontWeight: '700' }}>{`${attendancePercentage}%`}</div>
          </CircularProgressbarWithChildren>
        </Stack>

        <Typography fontSize="16px" fontWeight="500" color="#585858" textAlign="center" textTransform="capitalize">
          analitycs for past three sundays
        </Typography>

        <div className="summary">
          {recentAnalytics.map(({ date, direction, value }, index) => (
            <div className="items" key={index}>
              <div className="itemTitle">{formatDateWithoutYear(date)}</div>
              <div
                className={`itemPercentage ${value === null ? "not" : direction === "Decrease" ? "negative" : "positive"
                  }`}
              >
                {value === null ? (
                  <HorizontalRuleIcon />
                ) : direction === "Decrease" ? (
                  <KeyboardArrowDownIcon />
                ) : (
                  <KeyboardArrowUpIcon />
                )}
                {value !== null ? `${value}%` : "N/A"}
              </div>
            </div>
          ))}
        </div>
      </Stack>
    </Box>
  );
};

export default FeaturedChart;
